export const accountActivationKeys = {
  all: ["account-activation"] as const,
  context: (token: string) => [...accountActivationKeys.all, "context", token] as const,
}
